import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, catchError, firstValueFrom, forkJoin, iif, map, Observable, of, Subject, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { jwtDecode } from "jwt-decode";
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private httpClient: HttpClient, private router: Router) { }

	private API_URL = environment.API_URL;
	private APPT_API_URL = environment.APPT_API_URL;
	private MASTERS_API_URL = environment.MASTERS_API_URL;
	private REPORT_API_URL = environment.REPORT_API_URL;
	private mailCountChange = new Subject<any>();
	private mailOnlyCountChange = new Subject<any>();

	private callJoinSubject = new Subject<any>();
	callJoinData$ = this.callJoinSubject.asObservable();
	sendCallJoinStatus(data: boolean) {
		this.callJoinSubject.next(data);
	}

	private sessionExpMsg = new Subject<any>();

	sendSessionExpMessage() {
		this.sessionExpMsg.next(null);
	}
	getSessionExpMessage(): Observable<any> {
		return this.sessionExpMsg.asObservable();
	}

	sendCountChangeEvent() {
		this.mailCountChange.next(null);
	}
	getCountChangeEvent(): Observable<any> {
		return this.mailCountChange.asObservable();
	}

	sendOnlyCountChangeEvent() {
		this.mailOnlyCountChange.next(null);
	}
	getOnlyCountChangeEvent(): Observable<any> {
		return this.mailOnlyCountChange.asObservable();
	}

	private viewportSubject = new BehaviorSubject<any>(null);
	viewportData$ = this.viewportSubject.asObservable();
	setViewportData(data: any): void {
		this.viewportSubject.next(data);
	}

	getDefaultDateRange(returnString: boolean) {
		let today = new Date();
		let yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		return {
			start_date: returnString ? this.getDateStringFromDate(yesterday) : yesterday,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}

	getDefaultDateRange3Months(returnString: boolean) {
		let today = new Date();
		let fromDate = new Date();
		fromDate.setDate(fromDate.getDate() - 90);
		return {
			start_date: returnString ? this.getDateStringFromDate(fromDate) : fromDate,
			end_date: returnString ? this.getDateStringFromDate(today) : today
		}
	}

	/* getDateStringFromDate(date: any, format="YYYY-MM-DD") {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = year + "-" + monthStr + "-" + dayStr;
		return fromStr;
	} */

	getDateStringFromDate(date: any, format: string = "YYYY-MM-DD"): string | null {
		if (!date) {
			return null;
		}
		if (typeof date === 'string' || typeof date === 'number') {
			date = new Date(date);
		}
		if (!(date instanceof Date) || isNaN(date.getTime())) {
			return null;
		}
		const formattedDate = moment(date).format(format);
		return formattedDate;
	}

	getDateFromDateString(date: any) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		try {
			date = date.split("T")[0];
			var dateArr = date.split("-");
			date = new Date(dateArr.join("/"));
		} catch (error) {
			date = null;
		}
		return date;
	}

	public getHomeURL() {
		const userType: any = localStorage.getItem("userType");
		if (userType != 'company' && userType != 'branch' && userType != 'vessel' && userType != 'wellness') {
			/* return "/app/appointment-list"; */
			return "/app/schedule";
		} else if (userType == 'company' || userType == 'branch') {
			return "/app/company-appointment-list";
		} else if (userType == 'vessel' || userType == 'wellness') {
			return "/app/wellness";
		} else {
			return "/login";
		}
	}

	navigateToLogin(storeState: boolean) {
		localStorage.clear();
		localStorage.setItem("sessionexpire", "true");
		this.sendSessionExpMessage();
		if (storeState) {
			this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
		} else {
			this.router.navigate(['/login']);
		}
	}

	public currencyList() {
		return this.httpClient.get("./assets/files/currencies.json");
	}

	public loginAPI(user: any) {
		return this.httpClient.post(this.API_URL + "login", user);
	}

	public logoutUser() {
		localStorage.clear();
		localStorage.setItem("sessionexpire", "true");
		this.sendSessionExpMessage();
		this.router.navigate(['/login']);
	}

	public encrypt(id: any) {
		let params = { txt: id };
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "encrypt", options);
	}

	public encryptMultiple(ids: any): Observable<unknown> {
		let responses: any = [];
		for (let i = 0; i < ids.length; i++) {
			let id = ids[i];
			let params = { txt: id };
			const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
			const options = { params: new HttpParams(httpParams) };
			let response = this.httpClient.get(this.APPT_API_URL + "encrypt", options);
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public decrypt(id: any) {
		/* id = id.replace("%253D%253D", "==");
		id = id.replace("%253d%253d", "==");
		id = id.replace("%3D%3D", "==");
		id = id.replace("%3d%3d", "=="); */
		try {
			id = decodeURIComponent(id);
		} catch (e) { }
		let params = { txt: id };
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "decrypt", options);
	}

	public decryptMultiple(ids: any): Observable<unknown> {
		let responses: any = [];
		for (let i = 0; i < ids.length; i++) {
			let id = ids[i];
			/* id = id.replace("%253D%253D", "==");
			id = id.replace("%253d%253d", "==");
			id = id.replace("%3D%3D", "==");
			id = id.replace("%3d%3d", "=="); */
			try {
				id = decodeURIComponent(id);
			} catch (e) { }
			let params = { txt: id };
			const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
			const options = { params: new HttpParams(httpParams) };
			let response = this.httpClient.get(this.APPT_API_URL + "decrypt", options);
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public generate_qr(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/generate_qr", data, { responseType: "blob" });
	}

	public verifyGoogleAuthOTP(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/verify_otp", options);
	}

	get_refresh_token_api_url() {
		return environment.API_URL + "refresh";
	}

	gettingRefreshToken = false;

	public getRefreshToken() {
		let username: any = localStorage.getItem("email");
		if (username) {
			var data = { username: username };
			if (!this.gettingRefreshToken) {
				this.gettingRefreshToken = true;
				this.httpClient.post(this.get_refresh_token_api_url(), data).subscribe((data: any) => {
					this.gettingRefreshToken = false;
					localStorage.setItem('mhs_token', data["AuthenticationResult"]["IdToken"]);
				}, (error) => {
					this.gettingRefreshToken = false;
				});
			}
		}
	}

	public checkTokenExpiry() {
		try {
			let token: any = localStorage.getItem('mhs_token');
			const decoded = jwtDecode(token);
			let ts: any = decoded.exp;
			let expiry: any = new Date(ts * 1000);
			let now: any = new Date();
			const diffTime = expiry - now;
			let hours = diffTime / 36e5;
			if (hours < 1) {
				this.getRefreshToken();
			}
		} catch (error) {
			this.getRefreshToken();
		}
	}

	public resetPassword(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "api/changePassword", data);
	}

	public addTokenToCollectionForMailNotification(deviceId: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/Save_device_id", { device_id: deviceId });
	}

	public getCompanyList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_company");
	}

	public getBranchListByCompany(companyId: any) {
		const httpParams: HttpParamsOptions = { fromObject: { company: companyId } } as HttpParamsOptions;
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/listbranchByCompany", { params: new HttpParams(httpParams) });
	}

	public getVesselList(company: any = null) {
		if (company) {
			const params: any = { company: company };
			const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
			const options = { params: new HttpParams(httpParams) };
			return this.httpClient.get(this.MASTERS_API_URL + "server/Users/listVesselByCompany", options);
		} else {
			return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_vessel");
		}
	}

	public getAppoitmentsExcel(data: any) {
		return this.httpClient.post(this.REPORT_API_URL + "server/Users/AppoinmentListExcel", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public getAppoitmentsPdf(data: any) {
		return this.httpClient.post(this.REPORT_API_URL + "server/Users/AppoinmentReportPDF", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public deleteAppt(id: any) {
		return this.httpClient.delete(this.APPT_API_URL + "server/Users/delete_appointment/" + id);
	}

	/* public getInoviceNo(id: any) {
		return this.httpClient.get(this.REPORT_API_URL + "server/Users/getInoviceNo/" + id);
	} */

	public addVideoCallEntry(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/create_update_VideocallEntry", data);
	}

	public changePaymentStatus(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/save_payment_status", data);
	}

	public changeApptStatus(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/save_appointmentStatus", data);
	}

	public sendVideoCallLink(apptId: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/VideoCallLink", { id: apptId });
	}

	public sendPaymentLink(apptId: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/PaymentLink/" + apptId + "/", {},);
	}

	public countryCodes() {
		return this.httpClient.get("./assets/files/countryCodes.json");
	}

	public checkUniqueCCID(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/checkUniqueCCID", data);
	}

	public getAppointmentDetails(id: any) {
		try {
			id = id.replace("%253D%253D", "==");
			id = id.replace("%253d%253d", "==");
			id = id.replace("%3D%3D", "==");
			id = id.replace("%3d%3d", "==");
		} catch (error) { }
		return this.httpClient.get(this.APPT_API_URL + "server/Users/EditApptData/" + id);
	}

	public getAppointmentDetailsRebook(id: any) {
		const params: any = { id: id };
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "server/Users/ReApptData", options);
	}

	public getPsychologistList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_psychologist");
	}

	public getDoctorList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_doctors");
	}

	public getRankCategoryList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_rank_category");
	}

	public getRankList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_ranks");
	}

	public getProfileList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllProfiles");
	}

	public getApptTypeList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_appttype");
	}

	public getNationalityList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_nationality");
	}

	public createAppointment(data: any, uId: any = null) {
		if (uId) {
			return this.httpClient.put(this.APPT_API_URL + "server/Users/register_user", data);
		} else {
			return this.httpClient.post(this.APPT_API_URL + "server/Users/register_user", data);
		}
	}

	public createCompanyAppointment(data: any, uId: any = null) {
		if (uId) {
			return this.httpClient.put(this.APPT_API_URL + "server/Users/register_user_company", data);
		} else {
			return this.httpClient.post(this.APPT_API_URL + "server/Users/register_user_company", data);
		}
	}

	public createBranch(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_branch", data);
	}

	public reset2fa(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/reset2fa", data);
	}

	public deleteClinic(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_clinic/" + id);
	}

	public getClinicDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditClinicData/" + id);
	}

	public createUpdateClinic(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/UpdateClinicData", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_clinic", data);
		}
	}

	public restoreClinic(id: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/restore_clinic_api/" + id, {});
	}

	public deleteDoctor(data: any) {
		const params: any = data;
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/delete_doctor", options);
	}

	public getDoctorDetails(id: any) {
		const params: any = { id: id };
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditDoctorData", options);
	}

	public createDoctor(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_doctor", data);
	}

	public restoreDoctor(id: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/restore_Doctor_api/" + id, {});
	}

	public deleteProfile(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_profile/" + id);
	}

	public getAllScaleList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/getAllScales");
	}

	public getProfileDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditProfileData/" + id);
	}

	public createUpdateProfile(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_profile", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_profile", data);
		}
	}

	public restoreProfile(id: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/restore_profile_api/" + id, {});
	}

	public deleteQuestion(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_question/" + id);
	}

	public getQuestionDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditQuestionData/" + id);
	}

	public createUpdateQuestion(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_question", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_question", data);
		}
	}

	public getAllProfileList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllProfiles");
	}

	public saveQuestionImage(formData: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/image_assign_que_api", formData);
	}

	public bulkCreateQuestionBank(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/BulkCreateQuestionBank", data);
	}

	public getAllLanguagesList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllLanguages");
	}

	public deleteLanguage(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_language/" + id);
	}

	public getLanguageDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditLanguageData/" + id);
	}

	public createUpdateLanguage(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_language", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_language", data);
		}
	}

	public restoreLanguage(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/restore_language_api/" + id);
	}

	public deleteScale(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_scales/" + id);
	}

	public getScaleDetails(id: any) {
		const params: any = { id: id };
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditScaleData", options);
	}

	public getQuestionBankList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/listquestion");
	}

	public createUpdateScale(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_scales", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_scales", data);
		}
	}

	public saveStdScore(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/Save_std_score", data);
	}

	public restoreScale(id: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/restore_scale_api/" + id, {});
	}

	public getScaleCategoryList() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/getAllCategories");
	}

	public deleteRankCategory(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_rankCategory/" + id);
	}

	public getRankCategoryDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditRankCategoryData/" + id);
	}

	public createUpdateRankCategory(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_rankCategory", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_rankCategory", data);
		}
	}

	public restoreRankCategory(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/restore_rank_category_api/" + id);
	}

	public deleteReportTemplate(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_reportTemplate/" + id);
	}

	public getReportTemplateDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditReportTemplateData/" + id);
	}

	public createUpdateReportTemplate(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/register_reportTemplate", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_reportTemplate", data);
		}
	}

	public restoreReportTemplate(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/restore_report_template_api/" + id);
	}

	public deleteVideocallTranslation(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/AllTranslation/" + id);
	}

	public getVideocallTranslation(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllTranslation/" + id);
	}

	public createUpdateVideocallTranslation(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/AllTranslation", data);
		} else {
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/AllTranslation", data);
		}
	}

	public deleteCurrency(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/CurrencyApi/" + id);
	}

	public getCurrencyDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/CurrencyApi/" + id);
	}

	public getCurrency(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/CurrencyApi", options);
	}

	public createUpdateCurrency(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/CurrencyApi", data);
		} else {
			delete data.id;
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/CurrencyApi", data);
		}
	}

	public restoreCurrency(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/restore_currency/" + id);
	}

	public deleteReportText(id: any) {
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/ReportTextApi/" + id);
	}

	public getReportTextDetails(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/ReportTextApi/" + id);
	}

	public createUpdateReportText(data: any) {
		if (data.id) {
			return this.httpClient.put(this.MASTERS_API_URL + "server/Users/ReportTextApi", data);
		} else {
			delete data.id;
			return this.httpClient.post(this.MASTERS_API_URL + "server/Users/ReportTextApi", data);
		}
	}

	public restoreReportText(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/restore_report_text/" + id);
	}

	public getUserInfo(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.post(this.APPT_API_URL + "server/Users/User_info", {}, options);
	}

	public getVideoCallEntry(id: any) {
		return this.httpClient.get(this.APPT_API_URL + "server/Users/get_VideocallEntry/" + id);
	}

	public getAgoraToken(data: any) {
		return this.httpClient.post(this.API_URL + "api/generateTokenApi/", data);
	}

	public chatFileUploadOld(file: any, userId: any) {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('user', userId);
		return this.httpClient.post(this.API_URL + "server/Users/chatFileUpload", formData)
	}

	public chatFileUpload(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/chatFileUpload", data)
	}

	public getUserAns(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_que_ans/" + id);
	}

	public getSwatQuestions(profile: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/swat_quetion_ans/" + profile);
	}

	public alert_que_get(apptId: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/alert_que_get/" + apptId);
	}

	public time_validation_user(apptId: any) {
		return this.httpClient.get(this.APPT_API_URL + "server/Users/time_validation_user/" + apptId);
	}

	public Api_to_save_user_call_status(id: any) {
		return this.httpClient.get(this.APPT_API_URL + "server/Users/Api_to_save_user_call_status/" + id);
	}

	public sendEmailToDoctor(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/sendEmailToDoctor", data);
	}

	public getUserConsent(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/getUserConsent", options);
	}

	public saveConsent(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/saveConsent", data);
	}

	public getAllUsedLanguages(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllUsedLanguages", options);
	}

	public getTranslation(data: any): Observable<any[]> {
		let response1 = this.httpClient.post(this.MASTERS_API_URL + "server/Users/AllTranslatedQuestions", data);
		let response2 = this.httpClient.get(this.MASTERS_API_URL + "server/Users/list_que_ans/" + data["appId"]);
		return forkJoin([response1, response2]);
	}

	public save_que(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/save_que", data);
	}

	public saveUserAns(data: any) {
		return this.httpClient.post(this.REPORT_API_URL + "server/Users/listUserAns", data);
	}

	public saveTestTime(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/save_time", data);
	}

	public getFeedbackQuestions() {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/AllFeedbackQuestions");
	}

	public saveFeedback(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/saveFeedback", data);
	}

	public translate_text_api(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/translate_text_api", data);
	}

	public notifyDoctor(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/sendPushNotificationToDoctor", data);
	}

	public notifyDoctorOnSlack(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/user_problem", data);
	}

	public assignDoctor(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/assignpsychologist", data);
	}

	public getMailBoxCount() {
		let params = {
			start: "1",
			length: "1",
			search: ""
		}
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "api/mailgun/mails", options);
	}

	public searchMailOld(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "api/mailgun/mails", options);
	}

	public searchMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mailsList", data);
	}

	/* public getSingleMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mailsList", data).pipe(
			switchMap((resA: any) =>
				resA.email.html_path ? this.httpClient.get(resA.email.html_path, { responseType: "text" }).pipe(
					map(resB => ({
						...resA,
						email: {
							...resA.email,
							body_html: resB
						}
					}))
				) : of(resA)
			), catchError(err => {
				console.error('Something went wrong', err);
				return of(null);
			})
		);
	} */

	public getMailContent(url: any) {
		return this.httpClient.get(url, { responseType: "text" });
	}

	public getMultipleMailDetails(ids: any): Observable<unknown> {
		let responses: any = [];
		for (let i = 0; i < ids.length; i++) {
			const httpParams: HttpParamsOptions = { fromObject: { id: ids[i] } } as HttpParamsOptions;
			const options = { params: new HttpParams(httpParams) };
			let response = this.httpClient.get(this.APPT_API_URL + "api/mailgun/mails", options);
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public getEventMails(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/cand_linkedmails", data);
	}

	public moveMailListtoFolder(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/movemailto", data);
	}

	public unlinkMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/unlink_mail", data);
	}

	public deleteMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/delete_mail", data);
	}

	public restoreMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/restore_mail", data);
	}

	public getOrSaveReportExtras(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/add_grossmanfacet_responce", data);
	}

	public getOrSaveReportExtras1(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/ReportText_responce", data);
	}

	public reportTemplateListPagination(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/listReportTemplate", options);
	}

	public GetScalesByProfileId(id: any) {
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/GetScalesByProfileId/" + id);
	}

	public getReport(id: any) {
		return this.httpClient.get(this.REPORT_API_URL + "server/Users/getReport/" + id);
	}

	public getReportPdf(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		return this.httpClient.get(this.REPORT_API_URL + "server/Users/generateMCMI4ReportNew", { params: new HttpParams(httpParams), observe: 'response', responseType: 'arraybuffer' });
	}

	public changeShareReport(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/shareUnshareReport", data);
	}

	public saveReport(data: any) {
		return this.httpClient.post(this.REPORT_API_URL + "server/Users/saveReport", data);
	}

	/* public uploadReport(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/UploadReport", data);
	} */

	public uploadReportNew(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/v1/UploadReport", data);
	}

	public getMailDetails(id: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/send_report_email/" + id + "/", { flag: "get" });
	}

	public send_report_email(id: any, data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/send_report_email/" + id + "/", data);
	}

	public getMailHistory(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mail_history", data);
	}

	public getMultipleApptDetails(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/user_details", data);
	}

	public mailStatusSet(mId: any) {
		var data = { mail_id: mId }
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mark_read", data);
	}

	public updateMail(data: any) {
		if (data.appt_id == undefined) {
			data.appt_id = null;
		}
		return this.httpClient.put(this.APPT_API_URL + "api/mailgun/mails", data);
	}

	public saveMail(data: any) {
		if (data.appt_id == undefined) {
			data.appt_id = null;
		}
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mails", data);
	}

	public saveMailNew(data: any) {
		if (data.appt_id == undefined) {
			data.appt_id = null;
		}
		if (data.id) {
			return this.httpClient.put(this.APPT_API_URL + "api/mailgun/mails", data);
		} else {
			return this.httpClient.post(this.APPT_API_URL + "api/mailgun/mails", data);
		}
	}

	public linkMail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/mailgun/link_mail", data);
	}

	public getBillPdf(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/invoice", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public deleteBill(id: any) {
		return this.httpClient.delete(this.APPT_API_URL + "server/Users/InvoiceApi/" + id);
	}

	public paid_unpaid(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/paid_unpaid", data);
	}

	public getBillDetails(id: any) {
		return this.httpClient.get(this.APPT_API_URL + "server/Users/InvoiceApi/" + id);
	}

	public createUpdateBill(params: any) {
		if (params.id) {
			return this.httpClient.put(this.APPT_API_URL + "server/Users/InvoiceApi/" + params.id, params);
		} else {
			return this.httpClient.post(this.APPT_API_URL + "server/Users/InvoiceApi", params);
		}
	}

	public changeDoctorColor(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/changeDoctorColor", data);
	}

	public listdoeappointment(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "server/Users/listdoeappointment", options);
	}

	public getonlinecandidate() {
		return this.httpClient.get(this.API_URL + "api/getonlinecandidate");
	}

	public deleteBranch(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.delete(this.MASTERS_API_URL + "server/Users/delete_branch", options);
	}

	public getBranchDetails(id: any) {
		const httpParams: HttpParamsOptions = { fromObject: { id: id } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/EditBranchData", options);
	}

	public createUpdateBranch(data: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/register_branch", data);
	}

	public restoreBranch(id: any) {
		return this.httpClient.post(this.MASTERS_API_URL + "server/Users/restore_branch_api?id=" + id, {});
	}

	public getCallCounts(data: any) {
		const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.MASTERS_API_URL + "server/Users/tata_tele_call_counts", options);
	}

	public fetchImageForCid(cid: string) {
		const cleanCid = cid.startsWith('cid:') ? cid.slice(4) : cid;
		return firstValueFrom(
			/* this.httpClient.get(`${this.API_URL}api/mail-image/${encodeURIComponent(cleanCid)}`) */
			this.httpClient.get(window.location.origin + "/assets/img/broken.png", { observe: 'response', responseType: 'arraybuffer' })
		);
	}

	public getManualReportSentReason(apptid: any) {
		const httpParams: HttpParamsOptions = { fromObject: { apptid: apptid } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "server/Users/get_manual_report_sent_reason", options);
	}

	public saveManualReportSentReason(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/manual_report_sent", data);
	}

	public checkIfAlreadyGivenOtherTest(ref_no: any) {
		const httpParams: HttpParamsOptions = { fromObject: { ref_no: ref_no } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "server/Users/get_appointments_by_ref_no", options);
	}

	public checkForNextAppointment(ref_no: any) {
		const httpParams: HttpParamsOptions = { fromObject: { ref_no: ref_no } } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.APPT_API_URL + "server/Users/get_appointments_by_ref_no", options);
	}

	public sendMSEemail(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "api/sendMSEemail", data);
	}

	public listAppointment(data: any) {
		return this.httpClient.post(this.APPT_API_URL + "server/Users/listappointment", data);
	}

	/* -----------------------File Upload APIs Start----------------------- */

	public fileUpload(filename: any, destination: string) {
		const formData = new FormData();
		formData.append('file', "");
		formData.append('filename', filename);
		formData.append('destination', destination);
		return this.httpClient.post(this.API_URL + "api/generate_presigned_url", formData);
	}

	public fileUploadMultiple(fileNames: string[], destination: string): Observable<any[]> {
		let responses: Observable<any>[] = [];
		for (let i = 0; i < fileNames.length; i++) {
			const formData = new FormData();
			formData.append('file', "");
			formData.append('filename', fileNames[i]);
			formData.append('destination', destination);
			let response = this.httpClient.post(this.API_URL + "api/generate_presigned_url", formData);
			responses.push(response);
		}
		return forkJoin(responses);
	}

	public uploadFileToS3(file: any, url: any) {
		return this.httpClient.put(url, file, { reportProgress: true });
	}
	/* -----------------------File Upload APIs End----------------------- */
}

export interface HttpParamsOptions {
	fromString?: string;
	fromObject?: {
		[param: string]: string | string[];
	};
	encoder?: HttpParameterCodec;
}

interface HttpParameterCodec {
	encodeKey(key: string): string
	encodeValue(value: string): string
	decodeKey(key: string): string
	decodeValue(value: string): string
}